import React from 'react'
import {MdDoubleArrow} from  "react-icons/md"
function Tick({p}) {
  return (
    <div className='thick'>
       
             
        <p>🚀{p}</p>
            
    </div>
  )
}

export default Tick